// @flow

import {darkBlack} from 'material-ui/styles/colors';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const colorManipulator = require('material-ui/utils/colorManipulator');


export default function theme(fontFamily: string): Object {
  return getMuiTheme({
    fontFamily,
    palette: {
      primary1Color: '#337ab7',
      disabledColor: (0, colorManipulator.fade)(darkBlack, 0.4),
      accent1Color: '#d70400'
    },
    toolbar: {
      height         : 40,
      titleFontSize  : 15,
      color          : 'white',
      backgroundColor: 'transparent', // '#333333',
      iconColor      : 'lightgray',
      separatorColor : 'lightgray',
    },
    tabs: {
      selectedTextColor: 'black',
      textColor: 'gray'
    },
    raisedButton: {
      textTransform: 'none',
      fontSize: 'small'
    }
  });
}



// WEBPACK FOOTER //
// ./src/theme.js